import { useMemo, useState } from "react";
import MxAutoCompleteField from "./MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "./MxAutoCompleteField/model/MxAutoCompleteField";
import { useGetAgentsQuery } from "@/src-refactor/modules/store/qrtk/services/users/users.qrtk";
import { MxCustomAgentItem } from "@rf-l1/items-autocomplete/MxItemAgents";
import HCheckArray from "@rf-helper/check-have-value";
import {
  agentAutoCompleteItem,
  agentAutoCompleteItemAdapter
} from "@rf/adapters/autocomplete-items/agentItemAdapters";

type omit = "items";

export interface MxSelectAgentsFieldProp
  extends Omit<MxAutoCompleteFieldProps, omit> {
  onlyStatus?: string[];
  onlyRoles?: number[];
  agencyId?: string;
  removerTeamLead?: boolean;
}
const MxSelectAgentsField = (props: MxSelectAgentsFieldProp) => {
  const [search, onSearch] = useState("");
  const GET_AGENTS = useGetAgentsQuery(
    {
      query: {
        q: search ?? "",
        page: 1,
        status: props?.onlyStatus ? props.onlyStatus?.join(",") : undefined,
        type: props?.onlyRoles ? props.onlyRoles.join(",") : undefined,
        agency: props.agencyId,
        teamless: props.removerTeamLead ? 1 : undefined
      }
    },
    {
      refetchOnMountOrArgChange: true
    }
  );

  const Items: agentAutoCompleteItem[] | [] = useMemo(() => {
    if (!HCheckArray(GET_AGENTS.data?.data)) return [];
    return GET_AGENTS.data!.data.map((agent, i) =>
      agentAutoCompleteItemAdapter({
        name: agent.name,
        id: agent.id,
        picture: agent.picture_url,
        agencyName: agent.agency.name,
        status: agent?.user_status,
        role: agent?.user_type?.name
      })
    );
  }, [GET_AGENTS.data?.data]);

  return (
    <MxAutoCompleteField
      {...props}
      onSearch={v => onSearch(v)}
      items={Items}
      loading={GET_AGENTS.status == "pending"}
      componentItem={MxCustomAgentItem}
      useCustomComponent={true}
    />
  );
};

export default MxSelectAgentsField;
